/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributeNote
 */
export interface AttributeNote {
    /**
     * 
     * @type {string}
     * @memberof AttributeNote
     */
    note?: string | null;
}

export function AttributeNoteFromJSON(json: any): AttributeNote {
    return AttributeNoteFromJSONTyped(json, false);
}

export function AttributeNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeNote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function AttributeNoteToJSON(value?: AttributeNote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
    };
}


